import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Course, CourseList, CourseTest, EmployeeReport } from 'src/app/shared/models/course';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { DataService } from 'src/app/shared/services/data.service';
import { EmpCourseTestCrudComponent } from '../emp-course-test-crud/emp-course-test-crud.component';
import { ExamAttendComponent } from '../exam-attend/exam-attend/exam-attend.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { Context } from 'src/app/shared/models/context';
import { EmployeeReportViewComponent } from '../employee-report-view/employee-report-view.component';

@Component({
  selector: 'app-emp-course-test-list',
  templateUrl: './emp-course-test-list.component.html',
  styleUrls: ['./emp-course-test-list.component.scss']
})
export class EmpCourseTestListComponent implements OnInit {

  public courses: CourseList[] = [];
  public courseTests: CourseTest[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public context!: Context;
  public isEmployeeExamAttend: boolean = false;
  public employeeReport: EmployeeReport;
  public subscription: any;
  public employeeExamAttendMap: { [key: number]: boolean } = {};

  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private courseService: CourseService,
    private dataService: DataService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getCourses();
      }
    });
    this.dataService.onRefreshCourseList().subscribe((shouldRefresh) => {
      if (shouldRefresh) {
        this.getCourses(); 
      }
    });
  }

  private getCourses(clear: boolean = true) {
    if (clear) {
      this.isLoading = true;
      this.courses = [];
    }
    this.courseService.getCourseList(this.context.employeeId).subscribe({
      next: (courses: CourseList[]) => {
        this.courses = courses
          .filter(course => course.courseStatus === "ACTIVE")
          .map(course => ({
            ...course,
            courseTestId: course.courseTestId
          }))
          .sort((a, b) => a.id - b.id);
        this.courses.forEach(course => {
          if (course.courseTestId) {
            this.checkexamattend(course.courseTestId);
          }
        });
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }

  public upsertCourse(course?: CourseList) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(EmpCourseTestCrudComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.course = course;
    modalRef.componentInstance.courses = this.courses.filter(t => t.id !== course?.id);
  }

  public viewReport(course?: CourseList) {
    if (!this.privilege.canEdit || !course.courseTestId) return;
    this.courseService.getEmployeeReport(course.courseTestId).subscribe({
      next: (report: EmployeeReport) => {
        const modalRef = this.modalService.open(EmployeeReportViewComponent, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.course = course;
        modalRef.componentInstance.employeeReport = report;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || 'Failed to load report.');
      }
    });
  }

  public checkexamattend(courseTestId: number): void {
    this.courseService.getIsEmployeeReport(this.context.employeeId, courseTestId).subscribe({
      next: (isAllowed: boolean) => {
        this.employeeExamAttendMap[courseTestId] = isAllowed;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}